import { getEnvVariable } from "./EnvFunctions";

const navigationUtils = {
  isRegisterAllowed: getEnvVariable("REACT_APP_IS_REGISTER_ALLOWED") ?? "",
};

const isRegisterAllowed = () => {
  // Handles both boolean true and string "true"
  return navigationUtils.isRegisterAllowed === "true";
};

export { navigationUtils, isRegisterAllowed };
